module.exports = __webpack_public_path__ + "img/dots-vertical.b12f96c6.svg";